var _circle, _path, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 66,
    viewBox: "0 0 63 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 31,
    fill: "#F3F4F6",
    stroke: "#D1D5DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4822 22.9822L40.7322 20.7322C41.7085 19.7559 43.2915 19.7559 44.2678 20.7322C45.2441 21.7085 45.2441 23.2915 44.2678 24.2678L25.1096 43.426C24.4047 44.1309 23.5352 44.649 22.5799 44.9336L19 46L20.0664 42.4202C20.351 41.4648 20.8691 40.5953 21.574 39.8904L38.4822 22.9822ZM38.4822 22.9822L42 26.5",
    stroke: "#374151",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 54,
    r: 10,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.25 54C41.25 48.6152 45.6152 44.25 51 44.25C56.3848 44.25 60.75 48.6152 60.75 54C60.75 59.3848 56.3848 63.75 51 63.75C45.6152 63.75 41.25 59.3848 41.25 54ZM51 50.25C51.4142 50.25 51.75 50.5858 51.75 51V54.75C51.75 55.1642 51.4142 55.5 51 55.5C50.5858 55.5 50.25 55.1642 50.25 54.75V51C50.25 50.5858 50.5858 50.25 51 50.25ZM51 58.5C51.4142 58.5 51.75 58.1642 51.75 57.75C51.75 57.3358 51.4142 57 51 57C50.5858 57 50.25 57.3358 50.25 57.75C50.25 58.1642 50.5858 58.5 51 58.5Z",
    fill: "#2093C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAlert);
export default __webpack_public_path__ + "static/media/edit-alert.41f35826cdf885d30542dac9b2bb9538.svg";
export { ForwardRef as ReactComponent };